import api from './api';

/**
 * Pro 360 dispatch-paperwork client. Mirrors v1 `dap/dispatch.pl::sendDispatch`:
 * downloads the per-driver PDF or emails it to the assigned driver.
 *
 * All routes are keyed by `legdispatch.recno` (the leg's `dispatchid`).
 */

export interface SendDispatchResult {
  success: boolean;
  recipient: string;
  message: string;
}

export interface DispatchPaperworkPreview {
  pronumber: string;
  legnum: number;
  driver_unit: string;
  driver_email: string;
  driver_first: string;
  driver_last: string;
}

const dispatchPaperworkService = {
  preview: async (dispatchRecno: number): Promise<DispatchPaperworkPreview> => {
    const r = await api.get<DispatchPaperworkPreview>(
      `/driver-dispatch/dispatch-paperwork/${dispatchRecno}/preview`,
    );
    return r.data;
  },

  downloadBlob: async (dispatchRecno: number): Promise<Blob> => {
    const r = await api.get<Blob>(
      `/driver-dispatch/dispatch-paperwork/${dispatchRecno}/pdf`,
      { responseType: 'blob' },
    );
    return r.data;
  },

  sendToDriver: async (
    dispatchRecno: number,
    altEmail?: string,
  ): Promise<SendDispatchResult> => {
    const r = await api.post<SendDispatchResult>(
      `/driver-dispatch/dispatch-paperwork/${dispatchRecno}/send`,
      altEmail ? { alt_email: altEmail } : {},
    );
    return r.data;
  },
};

export default dispatchPaperworkService;
